import React, { useState, useRef, useEffect } from "react";
import "./LedgerReg.css";

import headeLogo from "../../../../assets/images/shersoftnavLogo.png";
import WindowHeader from "../../../Layout/WindowHeader/WindowHeader";

import ComboBox from "../../../ComboBoxes/ComboBox";
import SherComboBox from "../../../ComboBoxes/SherComboBox";

import axios from "axios";
import Swal from "sweetalert2";
import { useDbContext } from "../../../../context/DbContext";
import { AuthContext } from "../../../../context/AuthContext";
import RenameLedger from "../../../RenameLedger/RenameLedger";

import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../../app/permissionsSlice";
import io from "socket.io-client";
import ActionToolbar from "../../../NavBars/ActionToolbar";
import AccoutHierarchyTree from "../../../Layout/AccountHierarchyTree/AccountHierarchyTree";

function LedgerReg({ onClose, val, underVal, zIndex }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const { agentCode } = React.useContext(AuthContext);
  const [showRenameLed, setShowRenameLedModal] = useState(false);
  const permissions = useSelector(selectMenuPermissions);

  const dropdownRef = useRef(null);
  //console.log("val==",val)
  const openRenameLedger = () => {
    if (!formData.lr_Name) {
      return;
    }

    if (formData.lr_Name === "") {
      alert("Ledger Name is required");
      return;
    }
    setShowRenameLedModal(true);
  };

  useEffect(() => {
    const socket = io(apiBaseUrl);
    socket.on("connect", () => {
      // //console.log("Connected to socket server");
    });

    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl]);

  useEffect(() => {
    setTimeout(() => {
      nameInputRef.current?.focus?.();
    }, 100);
  }, []);

  const emitDataUpdate = () => {
    const socket = io(apiBaseUrl);
    socket.emit("dataUpdated");
    socket.disconnect();
  };
  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };
  const [activeTab, setActiveTab] = useState("account");
  const [dataFound, setDataFound] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [debitAmount, setDebitAmount] = useState("");
  const [creditAmount, setCreditAmount] = useState("");
  const [selectedledgerName, setSelectedledgerName] = useState("");
  const [selectedItemCode, setSelectedUnder] = useState("");

  const [routeOptions, setRouteOptions] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  const [treeData, setTreeData] = useState([]);

  const [stateOptions, setStateOptions] = useState([
    { label: "Andhra Pradesh", value: "37" },
    { label: "Arunachal Pradesh", value: "12" },
    { label: "Assam", value: "18" },
    { label: "Bihar", value: "10" },
    { label: "Chhattisgarh", value: "22" },
    { label: "Goa", value: "30" },
    { label: "Gujarat", value: "24" },
    { label: "Haryana", value: "06" },
    { label: "Himachal Pradesh", value: "02" },
    { label: "Jharkhand", value: "20" },
    { label: "Karnataka", value: "29" },
    { label: "Kerala", value: "32" },
    { label: "Madhya Pradesh", value: "23" },
    { label: "Maharashtra", value: "27" },
    { label: "Manipur", value: "14" },
    { label: "Meghalaya", value: "17" },
    { label: "Mizoram", value: "15" },
    { label: "Nagaland", value: "13" },
    { label: "Odisha", value: "21" },
    { label: "Punjab", value: "03" },
    { label: "Rajasthan", value: "08" },
    { label: "Sikkim", value: "11" },
    { label: "Tamil Nadu", value: "33" },
    { label: "Telangana", value: "36" },
    { label: "Tripura", value: "16" },
    { label: "Uttar Pradesh", value: "09" },
    { label: "Uttarakhand", value: "05" },
    { label: "West Bengal", value: "19" },
  ]);

  const [stateCodeOptions, setStateCodeOptions] = useState([
    { label: "01", value: "01" },
    { label: "02", value: "02" },
    { label: "03", value: "03" },
    { label: "04", value: "04" },
    { label: "05", value: "05" },
    { label: "06", value: "06" },
    { label: "07", value: "07" },
    { label: "08", value: "08" },
    { label: "09", value: "09" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" },
    { label: "32", value: "32" },
    { label: "33", value: "33" },
    { label: "34", value: "34" },
    { label: "35", value: "35" },
    { label: "36", value: "36" },
    { label: "37", value: "37" },
    { label: "38", value: "38" },
  ]);

  const [locationOptions, setLocationOptions] = useState([]);

  const [subGroupOptions, setSubGroupOptions] = useState([]);

  const [dayOptions, setDayOptions] = useState([
    { label: "Sunday", value: 1 },
    { label: "Monday", value: 2 },
    { label: "Tuesday", value: 3 },
    { label: "Wednesday", value: 4 },
    { label: "Thursday", value: 5 },
    { label: "Friday", value: 6 },
    { label: "Saturday", value: 7 },
  ]);

  const [salesRateOptions, setSalesRateOptions] = useState([
    { label: "MRP", value: 1 },
    { label: "RETAIL", value: 2 },
    { label: "SPRETAIL", value: 3 },
    { label: "WHOLESALE", value: 4 },
    { label: "BRANCH", value: 5 },
  ]);

  const [customerNatureOptions, setCustomerNatureOptions] = useState([
    { label: "EXCELLENT", value: 1 },
    { label: "GOOD", value: 2 },
    { label: "AVERAGE", value: 3 },
  ]);
  const [ledcode, setledcode] = useState("");
  const [ledCodeValue, setLedCodeValue] = useState("");
  const [lh_idValue, setlh_idValue] = useState("");
  const [findSuccess, setFindSuccess] = useState(false);

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);

  const nameInputRef = useRef(null);
  const underInputRef = useRef(null);
  const salesmanInputRef = useRef(null);
  const add1InputRef = useRef(null);
  const add2InputRef = useRef(null);
  const add3InputRef = useRef(null);
  const add4InputRef = useRef(null);

  const gstInputRef = useRef(null);
  const CpersonInputRef = useRef(null);
  const pincodeInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const mobInputRef = useRef(null);
  const debitAmountInputRef = useRef(null);
  const creditAmountInputRef = useRef(null);
  const saveBtnRef = useRef(null);
  const editButtonRef = useRef(null);
  const dateRef = useRef(null);

  // ---- refs added so EVERY field in the form (including the ones added
  // later: Route, State, StateCode, Pan, Location, SubGroup, Order/Delivery Day,
  // Sales Rate, Second Name, Commission, Credit Amount, Days, Max Discount,
  // Customer Nature, Opening Balance and MSME fields) can participate in
  // Enter-key navigation and be reset on Clear. ----
  const routeInputRef = useRef(null);
  const stateInputRef = useRef(null);
  const stateCodeInputRef = useRef(null);
  const panInputRef = useRef(null);
  const locationInputRef = useRef(null);
  const subGroupInputRef = useRef(null);
  const orderDayInputRef = useRef(null);
  const deliveryDayInputRef = useRef(null);
  const salesRateInputRef = useRef(null);
  const secondNameInputRef = useRef(null);
  const commissionInputRef = useRef(null);
  const cAmountInputRef = useRef(null);
  const cDaysInputRef = useRef(null);
  const maxDiscountInputRef = useRef(null);
  const customerNatureInputRef = useRef(null);
  const msmeUdyamInputRef = useRef(null);
  const msmeTypeInputRef = useRef(null);
  const msmeAgreementInputRef = useRef(null);
  const msmeBusinessTypeInputRef = useRef(null);
  const areaInputRef = useRef(null);

  const [formData, setFormData] = useState({
    lr_Name: "" || val,
    ledcode: "",
    lr_Under: "" || underVal,
    lh_id: "",
    lr_Address1: "",
    lr_Address2: "",
    lr_Address3: "",
    lr_Address4: "",
    lr_Area: "", // area label
    lr_AreaId: "", // area numeric id (stored as city in DB)
    lr_Route: "", // route label
    lr_RouteId: "", // route numeric id → DB
    lr_State: "", // state character → DB
    lr_StateCode: "", // state code id → DB
    lr_Pincode: "",
    lr_Contactperson: "",
    lr_Mobile: "",
    lr_Gstno: "",
    lr_Email: "",
    lr_Pan: "",
    lr_SalesMan: "",
    lr_empid: "",
    lr_SecondName: "",
    lr_Location: "", // branch label
    lr_LocationId: "", // branch id → DB
    lr_SubGroup: "", // subgroup label
    lr_SubGroupId: "", // subgroup id → DB
    lr_OrderDate: "", // order day label
    lr_OrderDateId: "", // order day id → DB
    lr_DeliveryDate: "", // delivery day label
    lr_DeliveryDateId: "", // delivery day id → DB
    lr_SalesRate: "", // sales rate label
    lr_SalesRateId: "", // sales rate id → DB
    lr_CustomerNature: "", // customer nature character → DB
    lr_CAmount: "",
    lr_CDays: "",
    lr_CommissionPer: "",
    lr_MaxDiscount: "",
    lr_Active: 1,
    lr_CostCenter: 0,
    lr_MsmeEnabled: 0,
    lr_MsmeUdyamNo: "",
    lr_MsmeType: "",
    lr_MsmeAgreement: "",
    lr_MsmeBusinessType: "",
    lr_debit: "0.000",
    lr_credit: "0.000",
    lr_date: getCurrentDate(),
  });

  console.log("ledgereg data ==>", formData);

  const handleClear = () => {
    // SherComboBox keeps its own internal display text, so just resetting
    // formData isn't enough — every combobox must be told to clear itself too.
    [
      nameInputRef,
      underInputRef,
      routeInputRef,
      stateInputRef,
      stateCodeInputRef,
      salesmanInputRef,
      locationInputRef,
      subGroupInputRef,
      orderDayInputRef,
      deliveryDayInputRef,
      salesRateInputRef,
      customerNatureInputRef,
      areaInputRef,
    ].forEach((ref) => ref.current?.clearInput?.());

    setFormData({
      lr_Name: "",
      ledcode: "",
      lr_Under: "",
      lh_id: "",
      lr_Address1: "",
      lr_Address2: "",
      lr_Address3: "",
      lr_Address4: "",
      lr_Area: "",
      lr_AreaId: "",
      lr_Route: "",
      lr_RouteId: "",
      lr_State: "",
      lr_StateCode: "",
      lr_Pincode: "",
      lr_Contactperson: "",
      lr_Mobile: "",
      lr_Gstno: "",
      lr_Email: "",
      lr_Pan: "",
      lr_SalesMan: "",
      lr_empid: "",
      lr_SecondName: "",
      lr_Location: "",
      lr_LocationId: "",
      lr_SubGroup: "",
      lr_SubGroupId: "",
      lr_OrderDate: "",
      lr_OrderDateId: "",
      lr_DeliveryDate: "",
      lr_DeliveryDateId: "",
      lr_SalesRate: "",
      lr_SalesRateId: "",
      lr_CustomerNature: "",
      lr_CAmount: "",
      lr_CDays: "",
      lr_CommissionPer: "",
      lr_MaxDiscount: "",
      lr_Active: 1,
      lr_CostCenter: 0,
      lr_MsmeEnabled: 0,
      lr_MsmeUdyamNo: "",
      lr_MsmeType: "",
      lr_MsmeAgreement: "",
      lr_MsmeBusinessType: "",
      lr_debit: "0.000",
      lr_credit: "0.000",
      lr_date: getCurrentDate(),
    });

    setDebitAmount("");
    setCreditAmount("");
    setFindSuccess(false);
    fetchLednamesNames();
    fetchTree();
    setDataFound(false);

    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    setShowRenameLedModal(false);

    // Send the user back to the first field once everything is wiped.
    setTimeout(() => {
      nameInputRef.current?.focus?.();
    }, 0);
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    handleClear();
    try {
      await Promise.all([
        fetchLednamesNames(),
        fetchparent(),
        fetchTree(),
        fetchOtherRegOptions(),
        fetchEmployeeNames(),
      ]);
    } catch (error) {
      console.error("Error refreshing data:", error.message);
    }
    setTimeout(() => {
      setIsRefreshing(false);
    }, 600);
  };

  // ======================================================================
  // Unified Enter-key navigation
  // ----------------------------------------------------------------------
  // fieldRefMap / fieldTabMap / fieldOrder describe, in ONE place, the exact
  // order fields should be visited in (this matches the order they actually
  // appear on screen, across all 4 tabs). Because inactive-tab content is
  // unmounted, focusFieldById() will switch tabs first (if needed) and then
  // retry focusing for a few frames until the field has mounted.
  // ======================================================================
  const fieldRefMap = {
    lr_Name: nameInputRef,
    lr_Under: underInputRef,
    lr_Address1: add1InputRef,
    lr_Address2: add2InputRef,
    lr_Address3: add3InputRef,
    lr_Address4: add4InputRef,
    lr_Pincode: pincodeInputRef,
    lr_Area: areaInputRef,
    lr_Route: routeInputRef,
    lr_State: stateInputRef,
    lr_StateCode: stateCodeInputRef,
    lr_Mobile: mobInputRef,
    lr_SalesMan: salesmanInputRef,
    lr_Pan: panInputRef,
    lr_Email: emailInputRef,
    lr_Gstno: gstInputRef,
    lr_Location: locationInputRef,
    lr_SubGroup: subGroupInputRef,
    lr_OrderDay: orderDayInputRef,
    lr_DeliveryDay: deliveryDayInputRef,
    lr_SalesRate: salesRateInputRef,
    lr_Contactperson: CpersonInputRef,
    lr_SecondName: secondNameInputRef,
    lr_CommissionPer: commissionInputRef,
    lr_CAmount: cAmountInputRef,
    lr_CDays: cDaysInputRef,
    lr_MaxDiscount: maxDiscountInputRef,
    lr_CustomerNature: customerNatureInputRef,
    lr_debit: debitAmountInputRef,
    lr_credit: creditAmountInputRef,
    lr_MsmeUdyamNo: msmeUdyamInputRef,
    lr_MsmeType: msmeTypeInputRef,
    lr_MsmeAgreement: msmeAgreementInputRef,
    lr_MsmeBusinessType: msmeBusinessTypeInputRef,
  };

  const fieldTabMap = {
    lr_Name: "account",
    lr_Under: "account",
    lr_Address1: "address",
    lr_Address2: "address",
    lr_Address3: "address",
    lr_Address4: "address",
    lr_Pincode: "address",
    lr_Area: "address",
    lr_Route: "address",
    lr_State: "address",
    lr_StateCode: "address",
    lr_Mobile: "address",
    lr_SalesMan: "address",
    lr_Pan: "address",
    lr_Email: "address",
    lr_Gstno: "address",
    lr_Location: "address",
    lr_SubGroup: "address",
    lr_OrderDay: "address",
    lr_DeliveryDay: "address",
    lr_SalesRate: "address",
    lr_Contactperson: "address",
    lr_SecondName: "address",
    lr_CommissionPer: "address",
    lr_CAmount: "address",
    lr_CDays: "address",
    lr_MaxDiscount: "address",
    lr_CustomerNature: "address",
    lr_debit: "openingbalance",
    lr_credit: "openingbalance",
    lr_MsmeUdyamNo: "msme",
    lr_MsmeType: "msme",
    lr_MsmeAgreement: "msme",
    lr_MsmeBusinessType: "msme",
  };

  // This array IS the order. Re-arranging field navigation only ever means
  // re-ordering this list — nothing else needs to change.
  const fieldOrder = [
    "lr_Name",
    "lr_Under",
    "lr_Address1",
    "lr_Address2",
    "lr_Address3",
    "lr_Address4",
    "lr_Pincode",
    "lr_Area",
    "lr_Route",
    "lr_State",
    "lr_StateCode",
    "lr_Mobile",
    "lr_SalesMan",
    "lr_Pan",
    "lr_Email",
    "lr_Gstno",
    "lr_Location",
    "lr_SubGroup",
    "lr_OrderDay",
    "lr_DeliveryDay",
    "lr_SalesRate",
    "lr_Contactperson",
    "lr_SecondName",
    "lr_CommissionPer",
    "lr_CAmount",
    "lr_CDays",
    "lr_MaxDiscount",
    "lr_CustomerNature",
    "lr_debit",
    "lr_credit",
    "lr_MsmeUdyamNo",
    "lr_MsmeType",
    "lr_MsmeAgreement",
    "lr_MsmeBusinessType",
  ];

  const focusFieldById = (id, attempt = 0) => {
    const ref = fieldRefMap[id];
    const tab = fieldTabMap[id];
    if (!ref) return;

    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    }

    // Switching tabs unmounts/mounts content, so the ref may not exist yet
    // on the very next frame — retry a few times instead of failing silently.
    requestAnimationFrame(() => {
      if (ref.current && typeof ref.current.focus === "function") {
        ref.current.focus();
      } else if (attempt < 15) {
        setTimeout(() => focusFieldById(id, attempt + 1), 25);
      }
    });
  };

  const focusSaveOrEdit = () => {
    const saveEnabled = !(dataFound || isLoading || saveDisabled);
    const editEnabled = !(!dataFound || editDisabled || isLoading);

    if (saveEnabled && saveBtnRef.current) {
      saveBtnRef.current.focus();
    } else if (editEnabled && editButtonRef.current) {
      editButtonRef.current.focus();
    }
  };

  // Use this on every field's onKeyDown: onKeyDown={(e) => handleEnterNav(e, "lr_FieldId")}
  const handleEnterNav = (event, currentId) => {
    if (event.key !== "Enter" && event.key !== "Return") return;
    event.preventDefault();

    const idx = fieldOrder.indexOf(currentId);
    if (idx === -1) return;

    const nextId = fieldOrder[idx + 1];
    if (nextId) {
      focusFieldById(nextId);
    } else {
      // Last field in the form — jump to Save if it's enabled, else Edit.
      focusSaveOrEdit();
    }
  };
  // ======================================================================

  const handleSubmit = async () => {
    setSaveDisabled(true);

    if (formData.lr_Under && !formData.lh_id) {
      const matched = under.find(
        (opt) =>
          opt.label?.toLowerCase() === formData.lr_Under.trim().toLowerCase() ||
          opt.value?.toString() === formData.lr_Under.trim()
      );
      if (matched) {
        formData.lh_id = matched.value;
        formData.lr_Under = matched.label;
      }
    }

    if (Lednames.includes(formData.lr_Name || formData.ledcode)) {
      alert("Duplicate Ledger Name");
      setSaveDisabled(false);
      return;
    }
    if (!formData.lr_Name || !formData.lr_Under) {
      alert("Enter Data Correctly");
      setIsLoading(false);
      setSaveDisabled(false);
      return; // Stop execution if name or section is empty
    }

    const isValidUnder = under.some(opt => opt.value == formData.lh_id || opt.label == formData.lr_Under || opt.value == formData.lr_Under);
    if (!isValidUnder) {
      alert("Invalid Under (Group) selected");
      setIsLoading(false);
      setSaveDisabled(false);
      return;
    }

    if (formData.lr_Mobile.length !== 10 && formData.lr_Mobile.length !== 0) {
      alert("Invalid Mobile Number.");
      setIsLoading(false);
      setSaveDisabled(false);
      return; // Stop execution if mobile number is not 10 digits
    }
    if (formData.lr_Email && !validateEmail(formData.lr_Email)) {
      alert("Invalid email address");
      setIsLoading(false);
      setSaveDisabled(false);
      return;
    }
    try {
      setIsLoading(true);
      {
        // Make a POST request to your server with the form data
        const response = await axios.post(
          `${apiBaseUrl}/main/insertledger/${dbCode}`,
          formData,
        );

        // Check the response status and handle accordingly
        if (response.status === 200) {
          // Data submitted successfully

          // alert('Scheme Registered')
          // Swal.fire({
          //   position: "top-end",
          //   icon: "success",
          //   title: "Scheme registered",
          //   showConfirmButton: false,
          //   timer: 2000,
          // });

          alert("Ledger registered");
          // window.location.reload();
          if (val) {
            onClose();
          }
          handleClear();
          emitDataUpdate();
          nameInputRef.current.focus();
          setIsLoading(false);
        } else {
          // Handle other response statuses or errors
          console.error("Error submitting data:", response.data);
          setIsLoading(false);
          setSaveDisabled(false);
        }
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Error:", error.message);
      setIsLoading(false);
      setSaveDisabled(false);
    }
  };

  const handleUpdate = async () => {
    if (formData.lr_Under && !formData.lh_id) {
      const matched = under.find(
        (opt) =>
          opt.label?.toLowerCase() === formData.lr_Under.trim().toLowerCase() ||
          opt.value?.toString() === formData.lr_Under.trim()
      );
      if (matched) {
        formData.lh_id = matched.value;
        formData.lr_Under = matched.label;
      }
    }

    if (!formData.lr_Name || !formData.lr_Under) {
      alert("Enter Data Correctly");
      return; // Stop execution if name or section is empty
    }

    const isValidUnder = under.some(opt => opt.value == formData.lh_id || opt.label == formData.lr_Under || opt.value == formData.lr_Under);
    if (!isValidUnder) {
      alert("Invalid Under (Group) selected");
      setIsLoading(false);
      return;
    }

    if (
      formData.lr_Mobile &&
      formData.lr_Mobile.length !== 10 &&
      formData.lr_Mobile.length !== 0
    ) {
      alert("Invalid Mobile Number.");
      setIsLoading(false);
      return;
    }
    if (formData.lr_Email && !validateEmail(formData.lr_Email)) {
      alert("Invalid email address");
      setIsLoading(false);
      return;
    }
    try {
      {
        // Make a POST request to your server with the form data
        const response = await axios.post(
          `${apiBaseUrl}/main/spupdateledger/${dbCode}`,
          formData,
        );

        // Check the response status and handle accordingly
        if (response.status === 200) {
          // Data submitted successfully

          // alert('Scheme Registered')
          // Swal.fire({
          //   position: "top-end",
          //   icon: "success",
          //   title: "Scheme registered",
          //   showConfirmButton: false,
          //   timer: 2000,
          // });

          alert("Ledger Updated");
          emitDataUpdate();
          // window.location.reload();
          handleClear();
          nameInputRef.current.focus();
        } else {
          // Handle other response statuses or errors
          console.error("Error updating data:", response.data);
        }
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Error:", error.message);
    }
  };

  const [Lednames, setLednames] = useState([]);
  useEffect(() => {
    const fetchLednamesNames = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/spledgernames/${dbCode}`,
        );
        const ledDetails = response.data;
        const lednames = ledDetails.map((item) => ({
          label: item.LedName,
          value: item.Ledcode,
        }));
        setLednames(lednames);
      } catch (error) {
        console.error("Error fetching names Values:", error.message);
      }
    };

    fetchLednamesNames();
  }, [apiBaseUrl]);

  const fetchLednamesNames = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/spledgernames/${dbCode}`,
      );
      const ledDetails = response.data;
      const lednames = ledDetails.map((item) => ({
        label: item.LedName,
        value: item.Ledcode,
      }));
      setLednames(lednames);
    } catch (error) {
      console.error("Error fetching names Values:", error.message);
    }
  };

  const [under, setUnder] = useState([]);
  const fetchparent = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/spledgerheads/${dbCode}`,
      );
      const parDetails = response.data;
      const under = parDetails.map((item) => ({
        label: item.lh_name,
        value: item.lh_id,
      }));
      setUnder(under);
    } catch (error) {
      console.error("Error fetching names Values:", error.message);
    }
  };

  useEffect(() => {
    if (dbCode) {
      fetchparent();
    }
  }, [apiBaseUrl, dbCode]);

  useEffect(() => {
    if (underVal && under.length > 0) {
      const matched = under.find(
        (item) =>
          item.label?.toLowerCase() === underVal.toLowerCase() ||
          item.value?.toString() === underVal.toString()
      );
      if (matched) {
        setFormData((prev) => ({
          ...prev,
          lr_Under: matched.label,
          lh_id: matched.value,
        }));
      }
    }
  }, [underVal, under]);


  const fetchTree = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/accountregistration/getaccounttree/${dbCode}`);
      setTreeData(response.data);
    } catch (error) {
      console.error("Error fetching account tree:", error.message);
    }
  };

  const fetchOtherRegOptions = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/otherregistration/getoptions/${dbCode}`);
      const data = response.data || [];

      const routes = data
        .filter(item => item.Type === "Route" && item.Active !== 0)
        .map(item => ({ label: item.Name, value: Number(item.Auto ?? item.auto ?? 0) }));

      const areas = data
        .filter(item => item.Type === "City" && item.Active !== 0)
        .map(item => ({ label: item.Name, value: Number(item.Auto ?? item.auto ?? 0) }));

      const branches = data
        .filter(item => item.Type === "Location" && item.Active !== 0)
        .map(item => ({ label: item.Name, value: Number(item.Auto ?? item.auto ?? 0) }));

      const subgroups = data
        .filter(item => item.Type === "SubGroup" && item.Active !== 0)
        .map(item => ({ label: item.Name, value: Number(item.Auto ?? item.auto ?? 0) }));

      setRouteOptions(routes);
      setAreaOptions(areas);
      setLocationOptions(branches);
      setSubGroupOptions(subgroups);
    } catch (error) {
      console.error("Error fetching other registration options:", error.message);
    }
  };

  const handleCreateOtherRegOption = async (name, type) => {
    const labelType = type === 'City' ? 'Area' : 'Route';
    if (!window.confirm(`Do you want to create ${labelType} "${name}"?`)) {
      return;
    }
    try {
      const response = await axios.post(
        `${apiBaseUrl}/otherregistration/insert/${dbCode}`,
        {
          name: name,
          description: `Created via Ledger Registration`,
          type: type,
          takeuser: agentCode || 0,
        }
      );
      if (response.data.success) {
        alert(`${labelType} "${name}" created successfully!`);
        
        // Fetch new options list immediately to find the auto ID
        const getRes = await axios.get(`${apiBaseUrl}/otherregistration/getoptions/${dbCode}`);
        const data = getRes.data || [];
        const matchedItem = data.find(
          item => item.Type === type && item.Name?.toLowerCase() === name.toLowerCase()
        );
        
        if (matchedItem) {
          if (type === 'City') {
            setFormData((prev) => ({
              ...prev,
              lr_Area: matchedItem.Name,
              lr_AreaId: Number(matchedItem.Auto ?? matchedItem.auto ?? 0),
            }));
          } else if (type === 'Route') {
            setFormData((prev) => ({
              ...prev,
              lr_Route: matchedItem.Name,
              lr_RouteId: Number(matchedItem.Auto ?? matchedItem.auto ?? 0),
            }));
          }
        }
        await fetchOtherRegOptions();
      } else {
        alert(response.data.message || `Failed to create ${labelType}.`);
      }
    } catch (error) {
      console.error("Error creating registration option:", error.message);
      alert("Failed to create option.");
    }
  };

  useEffect(() => {
    if (dbCode) {
      fetchOtherRegOptions();
      fetchTree();
      fetchLednamesNames();
      fetchparent();
    }

    const socket = io(apiBaseUrl);
    socket.on("OtherRegistrationUpdated", () => {
      if (dbCode) {
        fetchOtherRegOptions();
      }
    });

    socket.on("dataUpdated", () => {
      if (dbCode) {
        fetchLednamesNames();
        fetchparent();
        fetchTree();
      }
    });

    socket.on("GroupUpdated", () => {
      if (dbCode) {
        fetchparent();
        fetchTree();
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl, dbCode]);

  const [employeeNames, setEmployeeNames] = useState([]);

  const fetchEmployeeNames = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchReg_empname/${dbCode}`,
      );

      const empNames = response.data.map((item) => ({
        label: item.name,
        value: item.Auto,
      }));
      setEmployeeNames(empNames);
    } catch (error) {
      console.error("Error fetching employee names:", error.message);
    }
  };

  useEffect(() => {
    if (dbCode) {
      fetchEmployeeNames();
    }
  }, [apiBaseUrl, dbCode]);

  const fetchLedgerDetails = async (name, code) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/main/spledgerFindbyname/${dbCode}`,
        { lr_Name: name, ledcode: code },
      );

      if (response.status === 200) { 
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);

        const foundData = response.data[0];
        if (!foundData) return;

        fetchExist(foundData.Ledcode);

        const formattedDate = new Date(foundData.date)
          .toISOString()
          .split("T")[0];

        setFormData({
          ...formData,
          lr_Name: foundData.LedName,
          ledcode: foundData.Ledcode,
          lr_Under: foundData.parentname,
          lh_id: foundData.lh_id,
          lr_Address1: foundData.add1,
          lr_Address2: foundData.add2,
          lr_Address3: foundData.add3,
          lr_Address4: foundData.add4,
          lr_Area: foundData.Area || "",
          lr_AreaId: foundData.city || "",
          lr_Route: foundData.Route || "",
          lr_RouteId: foundData.route || "",
          lr_State: foundData.state,
          lr_StateCode: foundData.stateCode,
          lr_Pincode: foundData.PinNo,
          lr_Contactperson: foundData.CPerson,
          lr_Mobile: foundData.Mobile,
          lr_Gstno: foundData.gstno,
          lr_Email: foundData.Email,
          lr_Pan: foundData.pan,
          lr_SalesMan: foundData.SalesMan,
          lr_empid: foundData.SalesMan,
          lr_SecondName: foundData.SecondName,
          lr_Location: "",
          lr_LocationId: foundData.Location,
          lr_SubGroup: "",
          lr_SubGroupId: foundData.SubGroup,
          lr_OrderDate: "",
          lr_OrderDateId: foundData.OrderDate,
          lr_DeliveryDate: "",
          lr_DeliveryDateId: foundData.DeliveryDate,
          lr_SalesRate: "",
          lr_SalesRateId: foundData.SalesRate,
          lr_CustomerNature: foundData.CustomerNature || "",
          lr_CommissionPer: foundData.CommissionPer !== undefined ? foundData.CommissionPer : "",
          lr_MaxDiscount: foundData.maxDiscount !== undefined ? foundData.maxDiscount : "",
          lr_CAmount: foundData.CAmount,
          lr_CDays: foundData.CDays,
          lr_Active: foundData.Active,
          lr_CostCenter: foundData.CostCenter,
          lr_MsmeEnabled: foundData.MsmeEnabled,
          lr_MsmeUdyamNo: foundData.MsmeUdyamNo,
          lr_MsmeType: foundData.MsmeType,
          lr_MsmeAgreement: foundData.MsmeAgreement,
          lr_MsmeBusinessType: foundData.MsmeBusinessType,
          lr_debit: foundData.atDebitAmount,
          lr_credit: foundData.atCreditAmount,
          lr_date: formattedDate,
        });

        setDataFound(true);
      } else {
        console.error("Error retrieving data:", response.data);
        setDataFound(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
      setDataFound(false);
    }
  };

  const handleFindByname = async () => {
    await fetchLedgerDetails(formData.lr_Name, formData.ledcode);

  };

  const handleFindBygst = async () => {
    try {
      // Make a GET request to your server with the selected name for finding data
      const response = await axios.get(
        `${apiBaseUrl}/main/spledgerFindbygstNo/${formData.lr_Gstno}/${dbCode}`,
      );

      // Check the response status and handle accordingly
      if (response.status === 200) {
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
        // Data retrieved successfully, update the form data
        const foundData = response.data[0]; // Assuming the response is an array with one item
        fetchExist(foundData.Ledcode);

        //   //////////////////console.log("data =", foundData);
        const formattedDate = new Date(foundData.date)
          .toISOString()
          .split("T")[0];
        setFormData({
          ...formData,
          lr_Name: foundData.LedName,
          ledcode: foundData.Ledcode,
          lr_Under: foundData.parentname,
          lh_id: foundData.lh_id,
          lr_Address1: foundData.add1,
          lr_Address2: foundData.add2,
          lr_Address3: foundData.add3,
          lr_Address4: foundData.add4,
          lr_Area: foundData.Area || "",
          lr_AreaId: foundData.city || "",
          lr_Route: foundData.Route || "",
          lr_RouteId: foundData.route || "",
          lr_State: foundData.state,
          lr_StateCode: foundData.stateCode,
          lr_Pincode: foundData.PinNo,
          lr_Contactperson: foundData.CPerson,
          lr_Mobile: foundData.Mobile,
          lr_Gstno: foundData.gstno,
          lr_Email: foundData.Email,
          lr_Pan: foundData.pan,
          lr_SalesMan: foundData.SalesMan,
          lr_empid: foundData.SalesMan,
          lr_SecondName: foundData.SecondName,
          lr_Location: "",
          lr_LocationId: foundData.Location,
          lr_SubGroup: "",
          lr_SubGroupId: foundData.SubGroup,
          lr_OrderDate: "",
          lr_OrderDateId: foundData.OrderDate,
          lr_DeliveryDate: "",
          lr_DeliveryDateId: foundData.DeliveryDate,
          lr_SalesRate: "",
          lr_SalesRateId: foundData.SalesRate,
          lr_CustomerNature: foundData.CustomerNature || "",
          lr_CommissionPer: foundData.CommissionPer !== undefined ? foundData.CommissionPer : "",
          lr_MaxDiscount: foundData.maxDiscount !== undefined ? foundData.maxDiscount : "",
          lr_CAmount: foundData.CAmount,
          lr_CDays: foundData.CDays,
          lr_Active: foundData.Active,
          lr_CostCenter: foundData.CostCenter,
          lr_MsmeEnabled: foundData.MsmeEnabled,
          lr_MsmeUdyamNo: foundData.MsmeUdyamNo,
          lr_MsmeType: foundData.MsmeType,
          lr_MsmeAgreement: foundData.MsmeAgreement,
          lr_MsmeBusinessType: foundData.MsmeBusinessType,
          lr_debit: foundData.atDebitAmount,
          lr_credit: foundData.atCreditAmount,
          lr_date: formattedDate,
        });
        setDataFound(true);
      } else {
        // Handle other response statuses or errors
        console.error("Error retrieving data:", response.data);
        setDataFound(false);
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Error:", error.message);
      setDataFound(false);
    }
  };

  const handleFindBymob = async () => {
    try {
      // Make a GET request to your server with the selected name for finding data
      const response = await axios.get(
        `${apiBaseUrl}/main/spledgerFindbymob/${formData.lr_Mobile}/${dbCode}`,
      );

      // Check the response status and handle accordingly
      if (response.status === 200) {
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
        // Data retrieved successfully, update the form data
        const foundData = response.data[0]; // Assuming the response is an array with one item
        // //////////////////console.log("data =", foundData);

        fetchExist(foundData.Ledcode);

        const formattedDate = new Date(foundData.date)
          .toISOString()
          .split("T")[0];

        setFormData({
          ...formData,
          lr_Name: foundData.LedName,
          ledcode: foundData.Ledcode,
          lr_Under: foundData.parentname,
          lh_id: foundData.lh_id,
          lr_Address1: foundData.add1,
          lr_Address2: foundData.add2,
          lr_Address3: foundData.add3,
          lr_Address4: foundData.add4,
          lr_Area: foundData.Area || "",
          lr_AreaId: foundData.city || "",
          lr_Route: foundData.Route || "",
          lr_RouteId: foundData.route || "",
          lr_State: foundData.state,
          lr_StateCode: foundData.stateCode,
          lr_Pincode: foundData.PinNo,
          lr_Contactperson: foundData.CPerson,
          lr_Mobile: foundData.Mobile,
          lr_Gstno: foundData.gstno,
          lr_Email: foundData.Email,
          lr_Pan: foundData.pan,
          lr_SalesMan: foundData.SalesMan,
          lr_empid: foundData.SalesMan,
          lr_SecondName: foundData.SecondName,
          lr_Location: "",
          lr_LocationId: foundData.Location,
          lr_SubGroup: "",
          lr_SubGroupId: foundData.SubGroup,
          lr_OrderDate: "",
          lr_OrderDateId: foundData.OrderDate,
          lr_DeliveryDate: "",
          lr_DeliveryDateId: foundData.DeliveryDate,
          lr_SalesRate: "",
          lr_SalesRateId: foundData.SalesRate,
          lr_CustomerNature: foundData.CustomerNature || "",
          lr_CommissionPer: foundData.CommissionPer !== undefined ? foundData.CommissionPer : "",
          lr_MaxDiscount: foundData.maxDiscount !== undefined ? foundData.maxDiscount : "",
          lr_CAmount: foundData.CAmount,
          lr_CDays: foundData.CDays,
          lr_Active: foundData.Active,
          lr_CostCenter: foundData.CostCenter,
          lr_MsmeEnabled: foundData.MsmeEnabled,
          lr_MsmeUdyamNo: foundData.MsmeUdyamNo,
          lr_MsmeType: foundData.MsmeType,
          lr_MsmeAgreement: foundData.MsmeAgreement,
          lr_MsmeBusinessType: foundData.MsmeBusinessType,
          lr_debit: foundData.atDebitAmount,
          lr_credit: foundData.atCreditAmount,
          lr_date: formattedDate,
        });
        setDataFound(true);
      } else {
        // Handle other response statuses or errors
        console.error("Error retrieving data:", response.data);
        setDataFound(false);
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Error:", error.message);
      setDataFound(false);
    }
  };

  const [countExist, setcountExist] = useState("");

  const fetchExist = async (code) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/schUsedEntry/${code}/${dbCode}`,
      );
      setcountExist(response.data[0].CountExists);
    } catch (error) {
      console.error("Error fetching employee names:", error.message);
    }
  };
  const handleDelete = async () => {
    if (countExist > 0) {
      alert("Entry used");
      return;
    }

    if (formData.lr_Name === "") {
      alert("invalid Name");
      return;
    }
    if (!window.confirm("Do You Want To Delete..?")) {
      return;
    }
    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/spdeleteLedger/${formData.ledcode}/${dbCode}`,
      );
      if (response.status === 200) {
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Scheme deleted",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
        alert("Account Deleted ");
        // window.location.reload();
        handleClear();
      } else {
        console.error("Error deleting data:", response.data);
        alert("Error deleting data");
      }
    } catch (error) {
      console.error("Error:", error.message);
      alert("Error deleting data");
    }
  };

  const getLocalIPAddress = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      return response.data.ip;
    } catch (error) {
      console.error("Error fetching IP address:", error);
      return "127.0.0.1"; // Fallback IP address
    }
  };

  // Function to authenticate and fetch GST details
  const fetchGSTDetails = async (gstNo) => {
    //////////////////console.log("gstno=",gstNo);

    try {
      const localIp = await getLocalIPAddress();

      //////////////////console.log("localip=",localIp);

      const apiUrl =
        "https://api.mastergst.com/einvoice/authenticate?email=shersoftware%40gmail.com";

      // Step 1: Authenticate and get the auth token
      const authResponse = await axios.get(apiUrl, {
        headers: {
          accept: "/",
          username: "mastergst",
          password: "Malli#123",
          ip_address: localIp,
          client_id: "ce357943-5598-4af5-8d7f-7119ef5dd2b3",
          client_secret: "2dbffc02-86b9-4a48-9782-03727edad504",
          gstin: "29AABCT1332L000",
        },
      });

      const authData = authResponse.data;

      if (authData.status_cd === "Success") {
        const authToken = authData.data.AuthToken;

        // Step 2: Fetch GST details using the auth token
        const gstApiUrl = `https://api.mastergst.com/einvoice/type/GSTNDETAILS/version/V1_03?param1=${gstNo}&email=shersoftware%40gmail.com`;

        const gstResponse = await axios.get(gstApiUrl, {
          headers: {
            accept: "/",
            ip_address: localIp,
            client_id: "ce357943-5598-4af5-8d7f-7119ef5dd2b3",
            client_secret: "2dbffc02-86b9-4a48-9782-03727edad504",
            username: "mastergst",
            "auth-token": authToken,
            gstin: "29AABCT1332L000",
          },
        });

        const gstData = gstResponse.data;

        if (gstData.status_cd === "1") {
          // Handle successful GST details retrieval
          //////////////////console.log('Trade Name:', gstData.data.TradeName);
          //////////////////console.log('Address Line 1:', gstData.data.AddrBno);
          // Handle other fields as needed
          return gstData.data;
        } else {
          console.error("GST API Error:", gstData.status_desc);
        }
      } else {
        console.error("Authentication Error:", authData.status_desc);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };


  const updateNavRefs = (refs) => {
    if (refs.saveButtonRef) {
      saveBtnRef.current = refs.saveButtonRef.current;
    } else if (refs.saveBtnRef) {
      saveBtnRef.current = refs.saveBtnRef.current;
    }
    if (refs.editButtonRef) {
      editButtonRef.current = refs.editButtonRef.current;
    }
  };

  const accountSettings = [
    { id: "costCenter", label: "Cost Center", field: "lr_CostCenter" },
    { id: "active", label: "Active", field: "lr_Active" },
  ];

  return (
    <div
      className="absolute inset-0 w-full h-full bg-[#f0f0f0] flex items-center justify-center pointer-events-auto"
      style={{ zIndex: zIndex || 101 }}
    >
      <div className="bg-white font-normal w-[99%] max-w-[1440px] h-[99%] max-h-[900px] border border-slate-200 shadow-md flex flex-col items-center absolute overflow-hidden">
        <WindowHeader
          title="Ledger Registration"
          logo={headeLogo}
          onClose={onClose}
          closeBtnClassName="w-6 h-6 border-none rounded-[5px] mr-2"
        />

        {/* -------------------------------------------------------------- */}
        <div className="w-full flex-shrink-0">
          <ActionToolbar
            width="100%"
            height="auto"
            bgColor="#EAF0FC"
            // buttonGap="5px"
            // arrowGap="5px"

            // Button visibility
            showSave={true}
            showPrint={true}
            showClear={true}
            showFind={true}
            showEdit={true}
            showDelete={true}
            showExit={true}
            showNavigation={false}
            // Button states
            saveDisabled={dataFound || isLoading || saveDisabled}
            editDisabled={!dataFound || editDisabled || isLoading}
            deleteDisabled={!dataFound || deleteDisabled || isLoading}
            dataFound={dataFound}
            // Permissions
            permissions={permissions}
            permissionKey="ledgerReg"
            // Event handlers
            onSave={handleSubmit}
            // onPrint={handlePrint}
            onClear={handleClear}
            onFind={handleFindByname}
            onEdit={handleUpdate}
            onDelete={handleDelete}
            onExit={onClose}
            // Ref callback to get button refs
            onRefsUpdate={updateNavRefs}
            showSettingsBar={true}
            settingsBarHeight="36px"
            onRefresh={handleRefresh}
            isRefreshing={isRefreshing}
            settingsOptions={[
              {
                label: "Rename Ledger",
                onClick: openRenameLedger,
              },
            ]}
          />
        </div>
        {/* --------------------layout-Body---------------- */}

        <div className="w-full flex-1 overflow-hidden min-h-0 flex">
          {/* --------Tabs------------------ */}
          <div className="w-[75%] h-full flex flex-col overflow-hidden min-h-0">
            {/* tab buttons */}
            <div className="w-full flex-shrink-0 border-b border-[#b8cce0]">
              <div className="flex gap-0.5 px-2 pt-3 ">
                {["Account", "Address", "Opening Balance", "MSME"].map(
                  (tab) => {
                    const key = tab.toLowerCase().replace(" ", "");
                    return (
                      <button
                        key={key}
                        onClick={() => setActiveTab(key)}
                        className={`px-[25px] py-[10px] text-[13px] font-medium  border-none cursor-pointer transition-all duration-150 font-sans
            ${
              activeTab === key
                ? "bg-[#E8EEF8] text-[##2C4ABB] rounded-t-xl tab-active-underline"
                : "bg-transparent text-[#1a2e4a] hover:bg-[#1a2e4a14]"
            }`}
                      >
                        {tab}
                      </button>
                    );
                  },
                )}
              </div>
            </div>
            <div className="flex-1 overflow-auto min-h-0 p-2">
              {activeTab === "account" && (
                <div className="w-full h-full bg-white p-5 box-border flex flex-col gap-3 overflow-y-auto scrollbar">
                  {/* --- Section Header --- */}
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-[#1a3abf] rounded-[8px] flex items-center justify-center text-white shrink-0 shadow-sm">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
                        <path d="M8 7h6M8 11h8" />
                      </svg>
                    </div>
                    <div className="flex flex-col">
                      <h2 className="text-[16px] font-bold text-[#1e293b] m-0">
                        Account Details
                      </h2>
                      <span className="text-[13px] text-[#64748b] mt-0.5">
                        Fill in the ledger account information below
                      </span>
                    </div>
                  </div>

                  {/* --- Form Fields --- */}
                  <div className="flex flex-col gap-4 max-w-[700px] mt-1">
                    {/* Ledger Name */}
                    <div className="flex flex-row items-start gap-4">
                      <div className="w-[150px] shrink-0 pt-2.5">
                        <label className="text-[13px] font-semibold text-[#334155]">
                          Ledger Name <span className="text-red-500">*</span>
                        </label>
                      </div>
                      <div className="flex-1 flex flex-col gap-1.5">
                        <SherComboBox
                          id="lr_Name"
                          name="lr_Name"
                          comboRef={nameInputRef}
                          options={Lednames}
                          value={formData.ledcode || formData.lr_Name}
                          onSelect={({ label, value }) =>
                            setFormData((prev) => ({
                              ...prev,
                              lr_Name: label,
                              ledcode: value,
                            }))
                          }
                          onInputChange={(text) => {
                            const trimmed = text.trim();
                            const matched = Lednames.find(
                              (item) =>
                                item.label?.toLowerCase() === trimmed.toLowerCase() ||
                                item.value?.toString() === trimmed
                            );
                            if (matched) {
                              setFormData((prev) => ({
                                ...prev,
                                lr_Name: matched.label,
                                ledcode: matched.value,
                              }));
                            } else {
                              setFormData((prev) => ({
                                ...prev,
                                lr_Name: text,
                                ledcode: "",
                              }));
                            }
                          }}
                          onFreeInput={(text) =>
                            setFormData((prev) => ({
                              ...prev,
                              lr_Name: text,
                              ledcode: "",
                            }))
                          }
                          showArrow={true}
                          clearable={false}
                          placeholder="Select or type ledger name..."
                          className="w-2/3 h-[34px]  outline-none"
                          inputClassName="rounded-[4px] border border-[#cbd5e1]"
                          onKeyDown={(e) => handleEnterNav(e, "lr_Name")}
                        />
                        <span className="text-[12px] text-[#94a3b8]">
                          Choose an existing ledger or enter a new name
                        </span>
                      </div>
                    </div>

                    {/* Under (Group) */}
                    <div className="flex flex-row items-start gap-4">
                      <div className="w-[150px] shrink-0 pt-2.5">
                        <label className="text-[13px] font-semibold text-[#334155]">
                          Under (Group) <span className="text-red-500">*</span>
                        </label>
                      </div>
                      <div className="flex-1 flex flex-col gap-1.5">
                        <SherComboBox
                          id="lr_Under"
                          name="lr_Under"
                          value={formData.lh_id || formData.lr_Under}
                          comboRef={underInputRef}
                          options={under}
                          onSelect={({ label, value }) =>
                            setFormData((prev) => ({
                              ...prev,
                              lr_Under: label,
                              lh_id: value,
                            }))
                          }
                          onInputChange={(text) => {
                            const trimmed = text.trim();
                            const matched = under.find(
                              (item) =>
                                item.label?.toLowerCase() === trimmed.toLowerCase() ||
                                item.value?.toString() === trimmed
                            );
                            if (matched) {
                              setFormData((prev) => ({
                                ...prev,
                                lr_Under: matched.label,
                                lh_id: matched.value,
                              }));
                            } else {
                              setFormData((prev) => ({
                                ...prev,
                                lr_Under: text,
                                lh_id: "",
                              }));
                            }
                          }}
                          onFreeInput={(text) =>
                            setFormData((prev) => ({
                              ...prev,
                              lr_Under: text,
                              lh_id: "",
                            }))
                          }
                          onKeyDown={(e) => handleEnterNav(e, "lr_Under")}
                          showArrow={true}
                          clearable={false}
                          placeholder="Select account group..."
                          className="w-2/3 h-[34px]  outline-none"
                          inputClassName="rounded-[4px] border border-[#cbd5e1]"
                        />
                        <span className="text-[12px] text-[#94a3b8]">
                          e.g. Current Assets, Liabilities, Capital
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* --- Info Banner --- */}
                  <div className="mt-4 max-w-[700px] bg-[#EEF2FF] border border-[#C7D2FE] rounded-[8px] p-4 flex gap-3 items-start">
                    <div className="text-[#4338CA] shrink-0 mt-0.5">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                      </svg>
                    </div>
                    <p className="text-[13px] font-medium text-[#4338CA] m-0 leading-snug">
                      Select the correct group under which this ledger should be
                      classified. This affects all financial reports.
                    </p>
                  </div>
                </div>
              )}

              {activeTab === "address" && (
                <div className="w-full h-full bg-white p-5 box-border flex flex-col gap-4 overflow-y-auto scrollbar">
                  {/* --- Section Header --- */}
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-[#1a3abf] rounded-[8px] flex items-center justify-center text-white shrink-0 shadow-sm">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    </div>
                    <div className="flex flex-col">
                      <h2 className="text-[16px] font-bold text-[#1e293b] m-0">
                        Address & Contact Details
                      </h2>
                      <span className="text-[13px] text-[#64748b] mt-0.5">
                        Enter the ledger address and contact information
                      </span>
                    </div>
                  </div>

                  {/* --- Form Fields Grid --- */}
                  <div className="grid grid-cols-2 gap-x-6 gap-y-4 max-w-[850px] mt-1 pb-6">
                    {/* Address 1 */}
                    <div className="flex flex-col gap-1.5 col-span-2">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Address 1
                      </label>
                      <input
                        type="text"
                        placeholder="Enter address line..."
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                        ref={add1InputRef}
                        onKeyDown={(e) => handleEnterNav(e, "lr_Address1")}
                        value={formData.lr_Address1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_Address1: e.target.value,
                          })
                        }
                      />
                    </div>

                    {/* Address 2 */}
                    <div className="flex flex-col gap-1.5 col-span-2">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Address 2
                      </label>
                      <input
                        type="text"
                        placeholder="Enter address line..."
                        value={formData.lr_Address2}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_Address2: e.target.value,
                          })
                        }
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                        ref={add2InputRef}
                        onKeyDown={(e) => handleEnterNav(e, "lr_Address2")}
                      />
                    </div>

                    {/* Address 3 */}
                    <div className="flex flex-col gap-1.5 col-span-2">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Address 3
                      </label>
                      <input
                        type="text"
                        placeholder="Enter address line..."
                        value={formData.lr_Address3}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_Address3: e.target.value,
                          })
                        }
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                        ref={add3InputRef}
                        onKeyDown={(e) => handleEnterNav(e, "lr_Address3")}
                      />
                    </div>

                    {/* Address 4 */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Address 4
                      </label>
                      <input
                        type="text"
                        placeholder="Street / Locality"
                        value={formData.lr_Address4}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_Address4: e.target.value,
                          })
                        }
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                        ref={add4InputRef}
                        onKeyDown={(e) => handleEnterNav(e, "lr_Address4")}
                      />
                    </div>

                    {/* PIN */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        PIN
                      </label>
                      <input
                        type="number"
                        placeholder="PIN Code"
                        value={formData.lr_Pincode}
                        ref={pincodeInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_Pincode: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_Pincode")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>
                      <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">Area</label>
                      <SherComboBox
                        id="lr_Area"
                        name="lr_Area"
                        comboRef={areaInputRef}
                        options={areaOptions}
                        value={formData.lr_AreaId || formData.lr_Area}
                        placeholder="Select area..."
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        creatable={true}
                        onCreateOption={(text) => handleCreateOtherRegOption(text, 'City')}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_Area: label,
                            lr_AreaId: value,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_Area: text,
                            lr_AreaId: "",
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_Area")}
                      />
                    </div>

                    {/* Route */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Route
                      </label>
                      <SherComboBox
                        id="lr_Route"
                        name="lr_Route"
                        comboRef={routeInputRef}
                        options={routeOptions}
                        value={formData.lr_RouteId || formData.lr_Route}
                        placeholder="Select route..."
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        creatable={true}
                        onCreateOption={(text) => handleCreateOtherRegOption(text, 'Route')}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_Route: label,
                            lr_RouteId: value,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_Route: text,
                            lr_RouteId: "",
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_Route")}
                      />
                    </div>

                    {/* State */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        State
                      </label>
                      <SherComboBox
                        id="lr_State"
                        name="lr_State"
                        comboRef={stateInputRef}
                        options={stateOptions}
                        value={formData.lr_State}
                        placeholder="Select state..."
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_State: label,
                            lr_StateCode: value,
                          }))
                        }
                        onFreeInput={(text) => {
                          const matchedState = stateOptions.find(opt => opt.label.toLowerCase() === text.toLowerCase());
                          setFormData((prev) => ({
                            ...prev,
                            lr_State: text,
                            lr_StateCode: matchedState ? matchedState.value : prev.lr_StateCode,
                          }));
                        }}
                        onKeyDown={(e) => handleEnterNav(e, "lr_State")}
                      />
                    </div>

                    {/* State Code */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        State Code
                      </label>
                      <SherComboBox
                        id="lr_StateCode"
                        name="lr_StateCode"
                        comboRef={stateCodeInputRef}
                        options={stateCodeOptions}
                        value={formData.lr_StateCode}
                        placeholder="Select code..."
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        onSelect={({ value }) => {
                          const matchedState = stateOptions.find(opt => opt.value === value);
                          setFormData((prev) => ({
                            ...prev,
                            lr_StateCode: value,
                            lr_State: matchedState ? matchedState.label : prev.lr_State,
                          }));
                        }}
                        onFreeInput={(text) => {
                          const matchedState = stateOptions.find(opt => opt.value === text);
                          setFormData((prev) => ({
                            ...prev,
                            lr_StateCode: text,
                            lr_State: matchedState ? matchedState.label : prev.lr_State,
                          }));
                        }}
                        onKeyDown={(e) => handleEnterNav(e, "lr_StateCode")}
                      />
                    </div>

                    {/* Mobile No */}
                    <div className="flex flex-col gap-1.5 col-span-2">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Mobile No
                      </label>
                      <div className="relative flex items-center w-full">
                        <input
                          type="number"
                          placeholder="Enter mobile number"
                          value={formData.lr_Mobile}
                          ref={mobInputRef}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              lr_Mobile: e.target.value,
                            })
                          }
                          onKeyDown={(e) => handleEnterNav(e, "lr_Mobile")}
                          className="w-full pl-3 pr-12 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                          style={{ height: "34px" }}
                        />
                        <button
                          type="button"
                          onClick={handleFindBymob}
                          className="absolute right-0 top-0 h-full w-[38px] flex items-center justify-center bg-[#f1f5f9] border-l border-[#cbd5e1] rounded-r-[4px] text-[#1a3abf] hover:bg-slate-200 transition-colors"
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                          </svg>
                        </button>
                      </div>
                    </div>

                    {/* Sales Man */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Sales Man
                      </label>
                      <SherComboBox
                        id="lr_Salesman"
                        name="lr_Salesman"
                        placeholder="Select salesman..."
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        value={formData.lr_SalesMan}
                        comboRef={salesmanInputRef}
                        options={employeeNames}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_SalesMan: label,
                            lr_empid: value,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_SalesMan: text,
                            lr_empid: "",
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_SalesMan")}
                      />
                    </div>

                    {/* PAN */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        PAN
                      </label>
                      <input
                        type="text"
                        placeholder="Enter PAN number"
                        value={formData.lr_Pan}
                        ref={panInputRef}
                        onChange={(e) =>
                          setFormData({ ...formData, lr_Pan: e.target.value })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_Pan")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* E-Mail */}
                    <div className="flex flex-col gap-1.5 col-span-2">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        E-Mail
                      </label>
                      <input
                        type="email"
                        placeholder="Enter email address"
                        value={formData.lr_Email}
                        ref={emailInputRef}
                        onChange={(e) =>
                          setFormData({ ...formData, lr_Email: e.target.value })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_Email")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* GST No */}
                    <div className="flex flex-col gap-1.5 col-span-2">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        GST No
                      </label>
                      <div className="relative flex items-center w-full">
                        <input
                          type="text"
                          placeholder="Enter GST number"
                          value={formData.lr_Gstno}
                          ref={gstInputRef}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              lr_Gstno: e.target.value,
                            })
                          }
                          onKeyDown={(e) => handleEnterNav(e, "lr_Gstno")}
                          className="w-full pl-3 pr-12 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                          style={{ height: "34px" }}
                        />
                        <button
                          type="button"
                          onClick={handleFindBygst}
                          className="absolute right-0 top-0 h-full w-[38px] flex items-center justify-center bg-[#f1f5f9] border-l border-[#cbd5e1] rounded-r-[4px] text-[#1a3abf] hover:bg-slate-200 transition-colors"
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                          </svg>
                        </button>
                      </div>
                    </div>

                    {/* Location */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Location
                      </label>
                      <SherComboBox
                        id="lr_Location"
                        name="lr_Location"
                        comboRef={locationInputRef}
                        options={locationOptions}
                        value={formData.lr_LocationId || formData.lr_Location}
                        placeholder="Select location..."
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_Location: label,
                            lr_LocationId: value,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_Location: text,
                            lr_LocationId: "",
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_Location")}
                      />
                    </div>

                    {/* SubGroup */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        SubGroup
                      </label>
                      <SherComboBox
                        id="lr_SubGroup"
                        name="lr_SubGroup"
                        comboRef={subGroupInputRef}
                        options={subGroupOptions}
                        value={formData.lr_SubGroupId || formData.lr_SubGroup}
                        placeholder="Select subgroup..."
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_SubGroup: label,
                            lr_SubGroupId: value,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_SubGroup: text,
                            lr_SubGroupId: "",
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_SubGroup")}
                      />
                    </div>

                    {/* Order Day */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Order Day
                      </label>
                      <SherComboBox
                        id="lr_OrderDay"
                        name="lr_OrderDay"
                        comboRef={orderDayInputRef}
                        options={dayOptions}
                        value={formData.lr_OrderDateId || formData.lr_OrderDate}
                        placeholder="Select day"
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_OrderDate: label,
                            lr_OrderDateId: value,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_OrderDate: text,
                            lr_OrderDateId: "",
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_OrderDay")}
                      />
                    </div>

                    {/* Delivery Day */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Delivery Day
                      </label>
                      <SherComboBox
                        id="lr_DeliveryDay"
                        name="lr_DeliveryDay"
                        comboRef={deliveryDayInputRef}
                        options={dayOptions}
                        value={
                          formData.lr_DeliveryDateId || formData.lr_DeliveryDate
                        }
                        placeholder="Select day"
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_DeliveryDate: label,
                            lr_DeliveryDateId: value,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_DeliveryDate: text,
                            lr_DeliveryDateId: "",
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_DeliveryDay")}
                      />
                    </div>

                    {/* Sales Rate */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Sales Rate
                      </label>
                      <SherComboBox
                        id="lr_SalesRate"
                        name="lr_SalesRate"
                        comboRef={salesRateInputRef}
                        placeholder="Select rate structure..."
                        options={salesRateOptions}
                        value={formData.lr_SalesRateId || formData.lr_SalesRate}
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        onSelect={({ label, value }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_SalesRate: label,
                            lr_SalesRateId: value,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_SalesRate: text,
                            lr_SalesRateId: "",
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_SalesRate")}
                      />
                    </div>

                    {/* Contact Person */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Contact Person
                      </label>
                      <input
                        type="text"
                        placeholder="Enter contact person"
                        value={formData.lr_Contactperson}
                        ref={CpersonInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_Contactperson: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_Contactperson")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* Second Name */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Second Name
                      </label>
                      <input
                        type="text"
                        placeholder="Enter second name"
                        value={formData.lr_SecondName}
                        ref={secondNameInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_SecondName: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_SecondName")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* Commission Per */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Commission Per
                      </label>
                      <input
                        type="text"
                        placeholder="0.00"
                        value={formData.lr_CommissionPer}
                        ref={commissionInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_CommissionPer: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_CommissionPer")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* Credit Amount */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Credit Amount
                      </label>
                      <input
                        type="text"
                        placeholder="0.00"
                        value={formData.lr_CAmount}
                        ref={cAmountInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_CAmount: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_CAmount")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* Days */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Days
                      </label>
                      <input
                        type="text"
                        placeholder="0"
                        value={formData.lr_CDays}
                        ref={cDaysInputRef}
                        onChange={(e) =>
                          setFormData({ ...formData, lr_CDays: e.target.value })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_CDays")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* Max Discount % */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Max Discount %
                      </label>
                      <input
                        type="text"
                        placeholder="0.00"
                        value={formData.lr_MaxDiscount}
                        ref={maxDiscountInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_MaxDiscount: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_MaxDiscount")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* Customer Nature */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        Customer Nature
                      </label>
                      <SherComboBox
                        id="lr_CustomerNature"
                        name="lr_CustomerNature"
                        comboRef={customerNatureInputRef}
                        options={customerNatureOptions}
                        value={formData.lr_CustomerNature}
                        placeholder="Select nature"
                        showArrow={true}
                        clearable={false}
                        inputWidth="100%"
                        inputHeight="34px"
                        inputClassName="border border-[#cbd5e1] rounded-[4px]"
                        inputStyle={{ fontSize: "13px", paddingLeft: "8px" }}
                        onSelect={({ label }) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_CustomerNature: label,
                          }))
                        }
                        onFreeInput={(text) =>
                          setFormData((prev) => ({
                            ...prev,
                            lr_CustomerNature: text,
                          }))
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_CustomerNature")}
                      />
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "openingbalance" && (
                <div className="w-full h-full bg-white p-3 box-border rounded-lg select-none overflow-y-auto scrollbar">
                  {" "}
                  {/* Header Section */}
                  <div className="flex items-center gap-4 mb-4">
                    <div className="p-2 box-border bg-[#1e40af] rounded-xl text-white flex items-center justify-center shadow-sm">
                      {/* Wallet / Balance Icon */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6A2.25 2.25 0 0 1 18.75 20.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9A2.25 2.25 0 0 0 18.75 6.75H5.25A2.25 2.25 0 0 0 3 9v3M9 3h6"
                        />
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-lg font-bold text-gray-900 leading-tight">
                        Opening Balance
                      </h2>
                      <p className="text-xs text-gray-500 mt-0.5">
                        Set the initial debit or credit balance for this ledger
                        account
                      </p>
                    </div>
                  </div>
                  {/* As on Date Picker Section */}
                  <div className="flex items-center gap-4 mb-2">
                    <label className="text-sm font-semibold text-gray-700 min-w-[80px]">
                      As on Date
                    </label>
                    <div className="relative flex items-center border border-gray-300 rounded-lg px-3 py-1.5 bg-white shadow-sm hover:border-gray-400 cursor-pointer transition-colors">
                      <span className="text-sm text-gray-900 font-bold mr-3">
                        01 / Apr / 2024
                      </span>
                      {/* Calendar Icon */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="w-4 h-4 text-gray-800 mr-2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                        />
                      </svg>
                      {/* Chevron Icon */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2.5}
                        stroke="currentColor"
                        className="w-3 h-3 text-gray-600"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m19.5 8.25-7.5 7.5-7.5-7.5"
                        />
                      </svg>
                    </div>
                  </div>
                  {/* Debit/Credit Amount Cards */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-[600px] mb-3">
                    {/* Debit Amount Card */}
                    <div className="bg-[#f3f7fc] border border-[#e2ecf7] rounded-xl p-4  flex flex-col gap-5 justify-center  shadow-sm min-h-[150px]">
                      <div>
                        <div className="flex items-center gap-2 text-[#1e40af] font-bold mb-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={3}
                            stroke="currentColor"
                            className="w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m19.5 4.5-15 15m0 0h11.25m-11.25 0V8.25"
                            />
                          </svg>
                          <span className="text-xs tracking-wider uppercase font-semibold">
                            Debit Amount
                          </span>
                        </div>
                        <input
                          className="w-full bg-white border border-gray-200 box-border rounded-lg py-3 px-4 text-gray-900 font-medium text-base focus:outline-none focus:border-blue-500 shadow-inner"
                          style={{ textAlign: "right" }}
                          value={formData.lr_debit}
                          ref={debitAmountInputRef}
                          type="number"
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              lr_debit: e.target.value,
                              lr_credit: "0.000",
                            })
                          }
                          onKeyDown={(e) => handleEnterNav(e, "lr_debit")}
                        />
                      </div>
                      <p className="text-[11px] text-gray-400 mt-1 font-medium tracking-wide">
                        Amount this account owes
                      </p>
                    </div>

                    {/* Credit Amount Card */}
                    <div className="bg-[#f3f7fc] border border-[#e2ecf7] rounded-xl p-4  flex flex-col gap-5 justify-center shadow-sm min-h-[130px]">
                      <div>
                        <div className="flex items-center gap-2 text-[#1e40af] font-bold mb-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={3}
                            stroke="currentColor"
                            className="w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                            />
                          </svg>
                          <span className="text-xs tracking-wider uppercase font-semibold">
                            Credit Amount
                          </span>
                        </div>
                        <input
                          style={{ textAlign: "right" }}
                          value={formData.lr_credit}
                          ref={creditAmountInputRef}
                          type="number"
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              lr_credit: e.target.value,
                              lr_debit: "0.000",
                            })
                          }
                          onKeyDown={(e) => handleEnterNav(e, "lr_credit")}
                          className="w-full bg-white border border-gray-200 box-border rounded-lg py-3 px-4 text-gray-900 font-medium text-base focus:outline-none focus:border-blue-500 shadow-inner"
                        />
                      </div>
                      <p className="text-[11px] text-gray-400 mt-1 font-medium tracking-wide">
                        Amount owed to this account
                      </p>
                    </div>
                  </div>
                  {/* Horizontal Divider Line */}
                  <hr className="border-gray-200 my-8 max-w-2xl" />
                  {/* Account Settings Checkbox Group */}
                  <div className="max-w-2xl">
                    <h3 className="text-xs font-bold text-gray-900 mb-4 tracking-wider uppercase">
                      Account Settings
                    </h3>
                    <div className="flex flex-col gap-4">
                      {accountSettings.map((setting) => (
                        <label
                          key={setting.id}
                          className="flex items-center gap-3 cursor-pointer group w-fit"
                        >
                          <input
                            type="checkbox"
                            checked={!!formData[setting.field]}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                [setting.field]: e.target.checked ? 1 : 0,
                              }))
                            }
                            className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 accent-[#1e40af]"
                          />
                          <span className="text-xs font-semibold text-gray-700 group-hover:text-gray-900 transition-colors">
                            {setting.label}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "msme" && (
                <div className="w-full h-full bg-white p-5 box-border flex flex-col gap-4 overflow-y-auto scrollbar">
                  {/* Header Section */}
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-[#1a3abf] rounded-[8px] flex items-center justify-center text-white shrink-0 shadow-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="w-5 h-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                        />
                      </svg>
                    </div>
                    <div className="flex flex-col">
                      <h2 className="text-[16px] font-bold text-[#1e293b] m-0">
                        MSME Registration
                      </h2>
                      <span className="text-[13px] text-[#64748b] mt-0.5">
                        Micro, Small & Medium Enterprise details for this ledger
                        account
                      </span>
                    </div>
                  </div>

                  {/* Enable MSME Checkbox */}
                  <div className="max-w-[850px]">
                    <label className="flex items-start gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={!!formData.lr_MsmeEnabled}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_MsmeEnabled: e.target.checked ? 1 : 0,
                          })
                        }
                        className="w-4 h-4 mt-0.5 rounded border-gray-300 accent-[#1a3abf]"
                      />
                      <div className="flex flex-col">
                        <span className="text-[13px] font-semibold text-[#334155]">
                          Enable MSME for this Ledger
                        </span>
                        <span className="text-[12px] text-[#94a3b8] mt-0.5">
                          Check this to fill in MSME registration details
                        </span>
                      </div>
                    </label>
                  </div>

                  {/* Form Fields — same grid pattern as Address tab */}
                  <div className="grid grid-cols-2 gap-x-6 gap-y-4 max-w-[850px] mt-1 pb-6">
                    {/* MSME Udayam Registration No — full width */}
                    <div className="flex flex-col gap-1.5 col-span-2">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        MSME Udayam Registration No
                      </label>
                      <input
                        type="text"
                        placeholder="UDYAM-XX-00-0000000"
                        value={formData.lr_MsmeUdyamNo}
                        ref={msmeUdyamInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_MsmeUdyamNo: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_MsmeUdyamNo")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border"
                        style={{ height: "34px" }}
                      />
                    </div>

                    {/* MSME Types */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        MSME Types
                      </label>
                      <select
                        value={formData.lr_MsmeType}
                        ref={msmeTypeInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_MsmeType: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_MsmeType")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border bg-white text-[#334155]"
                        style={{ height: "34px" }}
                      >
                        <option value="">Select MSME type</option>
                        <option value="None">None</option>
                        <option value="Micro">Micro</option>
                        <option value="Small">Small</option>
                        <option value="Medium">Medium</option>
                      </select>
                    </div>

                    {/* MSME Agreement */}
                    <div className="flex flex-col gap-1.5 col-span-1">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        MSME Agreement
                      </label>
                      <select
                        value={formData.lr_MsmeAgreement}
                        ref={msmeAgreementInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_MsmeAgreement: e.target.value,
                          })
                        }
                        onKeyDown={(e) => handleEnterNav(e, "lr_MsmeAgreement")}
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border bg-white text-[#334155]"
                        style={{ height: "34px" }}
                      >
                        <option value="">Select agreement type</option>
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                      </select>
                    </div>

                    {/* MSME Business Types — full width */}
                    <div className="flex flex-col gap-1.5 col-span-2">
                      <label className="text-[13px] font-semibold text-[#334155]">
                        MSME Business Types
                      </label>
                      <select
                        value={formData.lr_MsmeBusinessType}
                        ref={msmeBusinessTypeInputRef}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            lr_MsmeBusinessType: e.target.value,
                          })
                        }
                        onKeyDown={(e) =>
                          handleEnterNav(e, "lr_MsmeBusinessType")
                        }
                        className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border bg-white text-[#334155]"
                        style={{ height: "34px" }}
                      >
                        <option value="">Select business type</option>
                        <option value="Not Specified">Not Specified</option>
                        <option value="Trader">Trader</option>
                        <option value="Manufacturer">Manufacturer</option>
                        <option value="Service">Service</option>
                      </select>
                    </div>
                  </div>

                  {/* Compliance Notice */}
                  <div className="max-w-[850px] bg-[#EEF2FF] border border-[#C7D2FE] rounded-[8px] p-4 flex gap-3 items-start">
                    <div className="text-[#4338CA] shrink-0 mt-0.5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <p className="text-[13px] font-medium text-[#4338CA] m-0 leading-snug">
                      MSME details are required for compliance under the MSME
                      Development Act. Ensure the Udyam Registration number is
                      correct before saving.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* --------------------------------- */}
          {/* -----------------AccountHierarchyTree----------------- */}
          <div className="w-[25%] h-full overflow-hidden border-l border-[#b8cce0]">
            <AccoutHierarchyTree
              treeData={treeData}
              selectedName={formData.lr_Name}
              onSelect={(node) => {
                if (!node.isGroup) {
                  setFormData((prev) => ({
                    ...prev,
                    lr_Name: node.name,
                    ledcode: node.id,
                    lr_Under: node.lh_name,
                    lh_id: node.lh_id,
                  }));
                  fetchLedgerDetails(node.name, node.id);
                } else {
                  setFormData((prev) => ({
                    ...prev,
                    lr_Under: node.name,
                    lh_id: node.id,
                  }));
                }
              }}
            />
          </div>

          {/* ------------------------------------------ */}
        </div>

        {/* ----------------------------------------------- */}
      </div>

      {showRenameLed && (
        <RenameLedger
          onClose={() => {
            setShowRenameLedModal(false);
            handleClear();
          }}
          LedName={
            Array.isArray(formData.lr_Name)
              ? formData.lr_Name[1]
              : formData.lr_Name
          }
        />
      )}

      <style>{`
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(5px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .border-x {
    border-right: 1px solid #b8cce0;
    border-left: 1px solid #b8cce0;
  }
  .border-y {
    border-top: 1px solid #b8cce0;
    border-bottom: 1px solid #b8cce0;
  }
  .tab-active-underline {
    border-bottom: 3px solid #2C4ABB !important;
    margin-bottom: -1px;
  }
`}</style>
    </div>
  );
}

export default LedgerReg;